module.exports = __webpack_public_path__ + "img/reward_go.dc8ed6c1.svg";